import { useMutation } from '@tanstack/react-query';

import { createAndAuthenticate } from './services';

export const useIntegrationAuthentication = () =>
  useMutation({
    mutationKey: ['integration', 'oauth', 'authenticate'],
    mutationFn: ({ integrationType, code }) => createAndAuthenticate(integrationType, code),
  });
